import React from 'react';
import { Link } from 'react-router-dom';

const FAQHelpSection = ({ 
  title = "お困りですか？",
  message = "よくある質問で解決策を見つけられるかもしれません",
  showCommonQuestions = true,
  variant = 'default'
}) => {
  const commonQuestions = [
    { text: "ログインできません", hash: "#tech-4" },
    { text: "支払いに失敗しました", hash: "#tech-3" },
    { text: "メール認証が届かない", hash: "#account-2" },
    { text: "プランを変更したい", hash: "#plan-3" }
  ];

  const variants = {
    default: {
      container: 'bg-blue-50 border border-blue-200',
      title: 'text-blue-900',
      message: 'text-blue-700',
      button: 'bg-blue-600 hover:bg-blue-700 text-white',
      linkText: 'text-blue-600 hover:text-blue-700'
    },
    error: {
      container: 'bg-red-50 border border-red-200',
      title: 'text-red-900',
      message: 'text-red-700',
      button: 'bg-red-600 hover:bg-red-700 text-white',
      linkText: 'text-red-600 hover:text-red-700'
    },
    success: {
      container: 'bg-green-50 border border-green-200',
      title: 'text-green-900',
      message: 'text-green-700',
      button: 'bg-green-600 hover:bg-green-700 text-white',
      linkText: 'text-green-600 hover:text-green-700'
    },
    warning: {
      container: 'bg-yellow-50 border border-yellow-200',
      title: 'text-yellow-900',
      message: 'text-yellow-700',
      button: 'bg-yellow-600 hover:bg-yellow-700 text-white',
      linkText: 'text-yellow-600 hover:text-yellow-700'
    }
  };

  const theme = variants[variant];

  return (
    <div className={`rounded-lg p-6 ${theme.container}`}>
      <div className="flex items-start space-x-4">
        <div className="flex-shrink-0">
          <svg className={`w-6 h-6 ${theme.title}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        </div>
        <div className="flex-1 min-w-0">
          <h3 className={`text-lg font-semibold ${theme.title} mb-2`}>
            {title}
          </h3>
          <p className={`${theme.message} mb-4`}>
            {message}
          </p>
          
          {showCommonQuestions && (
            <div className="mb-4">
              <h4 className={`text-sm font-medium ${theme.title} mb-2`}>よくある質問:</h4>
              <ul className="space-y-1">
                {commonQuestions.map((question, index) => (
                  <li key={index}>
                    <Link 
                      to={`/faq${question.hash}`}
                      className={`text-sm ${theme.linkText} hover:underline`}
                    >
                      • {question.text}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          )}
          
          <div className="flex flex-col sm:flex-row gap-3">
            <Link
              to="/faq"
              className={`inline-flex items-center justify-center px-4 py-2 text-sm font-medium rounded-lg transition-colors ${theme.button}`}
            >
              <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
              </svg>
              よくある質問を見る
            </Link>
            <Link
              to="/dashboard"
              className={`inline-flex items-center justify-center px-4 py-2 text-sm font-medium bg-white ${theme.linkText} border border-current rounded-lg hover:bg-gray-50 transition-colors`}
            >
              マイページに戻る
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FAQHelpSection;